import React, {useEffect, useState} from 'react';
import {useField, useFormikContext} from "formik";
import {Input} from "@mantine/core";

function MantineDependantField(props) {
    const {dependantField, dependsOn, dependsOnTwo, calculateValueFunction, formatDisplay} = props;
    const [field, meta] = useField(dependantField['name']);
    const {values, setFieldValue} = useFormikContext();
    const [value, setValue] = useState(field.value);
    const [hasBeenTouched, setHasBeenTouched] = useState(false);

    useEffect(() => {
        if (values[dependsOn['name']] && values[dependsOn['name']] !== "") {
            setFieldValue(dependantField.name, calculateValueFunction());
            setValue(calculateValueFunction())
        }
    }, [values[dependsOn['name']], values[dependsOnTwo?.name]]);

    return (
        <Input.Wrapper
            {...props}
            id={`wrapper-${dependantField.name}`}
            label={dependantField.label}
            error={meta.error && hasBeenTouched && <div>{meta.error}</div>}
        >
            <Input
                {...props}
                id={dependantField.name}
                value={formatDisplay(value)}
                onBlur={() => {
                    setFieldValue(dependantField.name, value)

                    setHasBeenTouched(true)
                    //Used in replacement of:
                    //setTouched(dependantField.name, false)
                }}
                onChange={(e) => setValue(e.target.value)}
            />
        </Input.Wrapper>
    );
}

export default MantineDependantField;
